import { Alert } from '@mui/material';
import { useDeleteGroupsMutation } from 'api/ordering-service/ordering-service';
import ConfirmationDrawer from 'components/drawers/confirmation-drawer/confirmation-drawer.component';
import { useBulkEditDataGridContext } from 'components/inc-data-grid/bulk-edit-data-grid/bulk-edit-data-grid.context';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

type GroupDeleteDrawerProps = {
  open: boolean;
  close: () => void;
};

const GroupsDeleteDrawer = ({ open, close }: GroupDeleteDrawerProps) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const [deleteGroups] = useDeleteGroupsMutation();
  const { selectedRowIds } = useBulkEditDataGridContext();

  const handleDeleteGroups = async () => {
    try {
      await deleteGroups({ groupIds: selectedRowIds }).unwrap();
      enqueueSnackbar(t('GroupsDataGrid.additionalMenus.delete.alertMessage'), {
        severity: 'success',
      });
    } catch (_e) {}
  };

  return (
    <ConfirmationDrawer
      open={open}
      close={close}
      submitButtonLabel={t('drawer.groupsDeleteDrawer.submitButtonLabel')}
      onValid={handleDeleteGroups}
      cancel={close}
      color="error"
    >
      <Alert severity="info">
        {t('drawer.groupsDeleteDrawer.alertMessage', {
          count: selectedRowIds.length,
        })}
      </Alert>
    </ConfirmationDrawer>
  );
};

export default GroupsDeleteDrawer;
